import axios from './axios';

export const getPatient = () => axios.post('/api/Patients/List', {
	"limit": 1000,
	"offset": 0,
	"filter": {
	},
	"sorting": {
	"fieldName": "id",
	"direction": "asc"
	}
});

export const createPatient = (patient) => axios.post('/api/Patients/Add', patient);
export const getPatientById = (patientId) => axios.get('/api/Patients/' + patientId);

export const getPatientHistory = (patientId) => axios.get(`/api/AnswerReport/GetHistoryList?request=${patientId}`);

// export const getPatientsFromVqura = () =>
//   axios.get('https://vqura.in:8443/ords/clinicst/clinic/patient/');

export const getPatientsFromVqura = async () => {
  try {
    const res = await axios.get('https://vqura.in:8443/ords/clinicst/clinic/patient/');
    return res;
  } catch (error) {
    console.error('CORS or network error fetching Vqura patients:', error);
    // Return a similar structure with empty items, so your mapping logic won't break
    return { data: { items: [] } };
  }
};

// export const getPatientFromVquraById = async (patientId) => {
//   const res = await axios.get('https://vqura.in:8443/ords/clinicst/clinic/patient/');
//   if (res.data?.items) {
//     return res.data.items.find((p) => String(p.user_id) === String(patientId)) || null;
//   }
//   return null;
// };

export const getPatientFromVquraById = async (patientId) => {
  try {
    const res = await axios.get('https://vqura.in:8443/ords/clinicst/clinic/patient/');
    if (res.data?.items) {
      return res.data.items.find((p) => String(p.user_id) === String(patientId)) || null;
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch patient by ID from Vqura:', error);
    return null;
  }
};